(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bellvare-email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('BellvareSignup');
  if (!panel) return;
  const key = 'bellvare_signup_until_v1';
  const preview = new URLSearchParams(window.location.search).get('bv_signup_preview') === '1';
  const save = days => { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch (_) {} };
  const close = () => { panel.hidden = true; save(panel.querySelector('[data-bv-success]') ? 365 : 7); };
  panel.querySelector('.bv-signup-close').addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) close(); });
  if (panel.querySelector('[data-bv-success]')) { save(365); panel.hidden = false; return; }
  if (panel.querySelector('[data-bv-error]')) { panel.hidden = false; return; }
  try { if (!preview && Number(localStorage.getItem(key)) > Date.now()) return; } catch (_) {}
  if (window.Shopify && Shopify.designMode) return;
  let tries = 0;
  const show = () => {
    const active = document.activeElement;
    const busy = document.hidden || document.querySelector('dialog[open]') || (active && /INPUT|TEXTAREA|SELECT/.test(active.tagName));
    const banner = document.querySelector('#shopify-pc__banner');
    if (busy || (banner && banner.getBoundingClientRect().height > 0)) {
      if (++tries < 30) setTimeout(show, 3000);
      return;
    }
    panel.hidden = false;
    save(7);
  };
  setTimeout(show, 15000);
})();
  } catch(e) { console.error(e); }
})();

})();
